import { Controller } from "@hotwired/stimulus"

// Controls the workout day popup for viewing/canceling workouts
export default class extends Controller {
  static targets = ["popup"]

  toggle(event) {
    event.stopPropagation()
    const popup = this.popupTarget

    if (popup.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.popupTarget.classList.remove("hidden")
    // Close when clicking outside
    document.addEventListener("click", this.handleOutsideClick)
  }

  hide() {
    this.popupTarget.classList.add("hidden")
    document.removeEventListener("click", this.handleOutsideClick)
  }

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }
}